import classNames from 'classnames';
import { registredSymbolToSup } from 'modules/Abbreviations/utils/abbreviationsListToHTML';
import React from 'react';
import { TextAbbreviationJSON } from 'models';
import { intlGet } from 'utils/intlGet';
import styles from './styles.module.scss';

type Props = {
  abbreviation: TextAbbreviationJSON;
  onChange: () => void;
  onRemove: () => void;
  dataTestId?: string;
};

const AbbreviationDetails: React.FunctionComponent<Props> = (props) => {
  const { abbreviation, onChange, onRemove, dataTestId = 'abbreviationDetails' } = props;
  const updatedTerm = registredSymbolToSup(abbreviation.term);
  const updatedDefinition = registredSymbolToSup(abbreviation.definition);

  return (
    <div className={classNames(styles.abbreviationContainer, 'abbreviation-details')} data-testid={dataTestId}>
      <div className={styles.scroll} data-testid={`${dataTestId}-scroll`}>
        <span className={styles.term} dangerouslySetInnerHTML={{ __html: updatedTerm }} data-testid={`${dataTestId}-term`} />
        <span className={styles.definition} dangerouslySetInnerHTML={{ __html: updatedDefinition }} data-testid={`${dataTestId}-definition`}/>
      </div>
      <div className={styles.buttons} data-testid={`${dataTestId}-buttons`}>
        <button className={styles.button} onClick={onChange}>
          {intlGet('EditorToolbar.Abbreviation', 'Button.Change')}
        </button>
        <button className={styles.button} onClick={onRemove}>
          {intlGet('EditorToolbar.Abbreviation', 'Button.Remove')}
        </button>
      </div>
    </div>
  );
};

export default AbbreviationDetails;
